import { type ComponentType, useMemo } from 'react';
import { Flex, Text } from '@chakra-ui/react';
import DashboardSharpIcon from '@gamma/ui/icons/DashboardSharpIcon';
import DevicesSharpIcon from '@gamma/ui/icons/DevicesSharpIcon';
import { EntityAnalysisModalTab } from '@investigator/shared/constants';
import { i18n } from '@investigator/shared/localization';
import { EntityOverviewTab } from '../components/EntityAnalysisModal/EntityOverviewTab';
import { EDRDetailsTab } from '../components/EntityAnalysisModal/EDRDetailsTab';

const modalCopy = i18n.pages.entities.entityAnalysisModal;

interface TabConfig {
  icon: ComponentType;
  content: ComponentType;
}

// Tab configuration - fully data-driven
const TAB_CONFIG: Record<EntityAnalysisModalTab, TabConfig> = {
  [EntityAnalysisModalTab.EntityOverview]: {
    icon: DashboardSharpIcon,
    content: EntityOverviewTab,
  },
  [EntityAnalysisModalTab.EDRDetails]: {
    icon: DevicesSharpIcon,
    content: EDRDetailsTab,
  },
};

export const useEntityAnalysisModalTabs = (): {
  tabs: Array<{
    tab: EntityAnalysisModalTab;
    title: JSX.Element;
    content: ComponentType;
  }>;
} => {
  // Static tabs array with memoized titles
  const tabs = useMemo(
    () =>
      Object.entries(TAB_CONFIG).map(([tab, config]) => {
        const tabKey = tab as EntityAnalysisModalTab;
        return {
          tab: tabKey,
          title: (
            <Flex gap={2}>
              <config.icon />
              <Text>{modalCopy.tabs[tabKey]}</Text>
            </Flex>
          ),
          content: config.content,
        };
      }),
    [],
  );

  return { tabs };
};
